import React, { useState } from "react";
import AddBills from "../AddBills";
function BillList() {
    const data = false;
    const [isShow, setIsShow] = useState(false);

    const showModal = () => setIsShow(true);
    return (
        <div className="BoxStyle">
            <div className="container">
                <div className="title">THÔNG TIN XUẤT HÓA ĐƠN</div>
                <div className="BoxContent">
                    {data ? (<div className="ListContent">
                        <div className="itemBox">
                            <div className="companyName">Apec Group</div>
                            <div className="addressCompany"> 117 trần duy Hưng</div>
                            <div className="vatCode">1246800</div>
                        </div>
                        <div className="itemBox">
                            <div className="companyName">Apec Group</div>
                            <div className="addressCompany"> 117 trần duy Hưng</div>
                            <div className="vatCode">1246800</div>
                        </div>
                        <div className="btnAdd"><button onClick={showModal} className="btnStyle">Tạo thêm hóa đơn</button></div>
                    </div>) :
                        (
                            <div className="dataEmpty">
                                <img className="img-fluid" src="/images/ic_event_create.png" alt="" />
                                <h5>CHƯA CÓ HÓA ĐƠN NÀO ĐƯỢC TẠO</h5>
                                <p>Thông tin xuất hóa đơn sẽ được hiển thị ở đây</p>
                                <button className="btnStyle" onClick={showModal}>Tạo hóa đơn mới</button>
                            </div>
                        )
                    }
                </div>
            </div>
            <AddBills isShow={isShow} setIsShow={setIsShow} />
        </div>
    );
}
export default BillList;